// Shared constants + date helpers. `anchoredToday()` is the runtime source
// of truth — no more hard-coded 2026 date like the preview had.

import { anchoredToday } from './dateKeys.js';

export const MONTHS = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
export const MONTH_NAMES_FULL = ['January','February','March','April','May','June','July','August','September','October','November','December'];
export const DOW = ['S','M','T','W','T','F','S'];

export function getToday() {
  return anchoredToday();  // { year, month, day }
}

export function daysInMonth(year, month) {
  return new Date(year, month + 1, 0).getDate();
}
export function dowOf(year, month, day) {
  return new Date(year, month, day).getDay();
}

export const ACCENTS = {
  blue:   { name: 'Electric', color: '#2D9CFF' },
  cyan:   { name: 'Cyan',     color: '#22D3EE' },
  violet: { name: 'Violet',   color: '#A78BFA' },
  pink:   { name: 'Rose',     color: '#F472B6' },
  amber:  { name: 'Amber',    color: '#FFB547' },
  green:  { name: 'Mint',     color: '#30D394' },
};

// ─── Theme-aware accent resolution ─────────────────────────────────────
// Every habit stores an accent key (default: 'blue') that drives its tile
// glow on Dashboard and its bar + bullet on Analytics. The literal 'blue'
// color — #2D9CFF — is Cosmic's signature electric blue, which bleeds hard
// into Girlboss (supposed to be hot pink) and doesn't match the deeper /
// lighter editorial blues of the Professional themes either.
//
// The fix: 'Electric' semantically means "the theme's signature accent."
// Remap only that one key per theme; leave user-picked accents (Cyan,
// Violet, Rose, Amber, Mint) alone so if someone deliberately chose a
// color it stays across theme switches. No habit data needs to change.
//
// We can't import themeStore here (constants.js is its transitive dep),
// so resolveAccentColor takes `theme` as a parameter. A `useAccentColor`
// hook lives in themeStore for the component-side call.
const THEME_ACCENT_OVERRIDES = {
  'cosmic':             {},
  'professional-dark':  { blue: '#0A47B8' },  // deeper editorial blue
  'professional-light': { blue: '#6E7E5F' },  // moss green — Relaxed signature
  'girlboss':           { blue: '#FF3E6C' },  // hot pink, matches theme accent
};

export function resolveAccentColor(accentKey, theme) {
  const override = THEME_ACCENT_OVERRIDES[theme];
  if (override && override[accentKey]) return override[accentKey];
  return ACCENTS[accentKey]?.color || ACCENTS.blue.color;
}
